import { api } from './apiClient';

/** Bloco #56: conta Google do profissional que hospeda as salas do Meet. */
export type GoogleMeetStatus = {
  /** Integração ligada no servidor (cliente OAuth do Google configurado). */
  configured: boolean;
  connected: boolean;
  email: string | null;
  /** "ACESSO_REVOGADO": o acesso foi removido na conta Google; reconectar. */
  error: string | null;
};

export function getGoogleMeetStatus(): Promise<GoogleMeetStatus> {
  return api.get<GoogleMeetStatus>('/teleconsulta/google');
}

/** Endereço da tela de consentimento do Google (o navegador vai até lá e volta para `/?google=...`). */
export function startGoogleMeetConnect(): Promise<{ url: string }> {
  return api.post<{ url: string }>('/teleconsulta/google/conectar');
}

export function disconnectGoogleMeet(): Promise<unknown> {
  return api.delete('/teleconsulta/google');
}

/** Mensagem da volta do Google (`?google=conectado` ou `?google=erro&motivo=...`). */
export function googleReturnMessage(search: string): { ok: boolean; text: string } | null {
  const params = new URLSearchParams(search);
  const result = params.get('google');
  if (!result) return null;
  if (result === 'conectado') return { ok: true, text: 'Conta Google conectada. As teleconsultas passam a ter sala própria no Meet.' };
  const motivos: Record<string, string> = {
    negado: 'A conexão foi cancelada na tela do Google.',
    'sem-permissao': 'Marque a permissão do Google Meet na tela do Google para o Allodos criar as salas.',
    expirado: 'O pedido de conexão expirou. Clique em "Conectar" de novo.',
  };
  return { ok: false, text: motivos[params.get('motivo') ?? ''] ?? 'Não foi possível conectar a conta Google. Tente de novo.' };
}
